import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { LazyPermissionsExportPage } from '@confluence/site-settings/entry-points/PermissionsExportPage';

const PERMISSIONS_EXPORT_ANALYTICS_SOURCE = 'adminPermissionsExport';

export const PermissionsExportRoute = () => <LazyPermissionsExportPage />;
PermissionsExportRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: PERMISSIONS_EXPORT_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
